import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toastEvents: Observable<ToastEvent>;
  private _toastEvents = new Subject<ToastEvent>();

  constructor() {
    this.toastEvents = this._toastEvents.asObservable();
  }

  success(message: string) {
    this._toastEvents.next({
      message,
      type: EventTypes.success,
      autohide: true,
      delay: 5000,
    });
  }

  info(message: string) {
    this._toastEvents.next({
      message,
      type: EventTypes.info,
      autohide: true,
      delay: 5000,
    });
  }

  error(message: string) {
    this._toastEvents.next({
      message,
      type: EventTypes.error,
      autohide: true,
      delay: 5000,
    });
  }

  warning(message: string) {
    this._toastEvents.next({
      message,
      type: EventTypes.warning,
      autohide: true,
      delay: 5000,
    });
  }
}

export interface ToastEvent {
  type: EventTypes;
  message: string;
  autohide: boolean;
  delay: number;
}

export enum EventTypes {
  success = 'success',
  info = 'info',
  warning = 'warning',
  error = 'error',
}
